import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscoveryChatComponent } from './discovery-chat/discovery-chat.component';
import { ChatRollComponent } from './chat-roll/chat-roll.component';
import { ChatCurrentQuestionComponent } from './chat-current-question/chat-current-question.component';
import { ChatResponseOptionsComponent } from './chat-response-options/chat-response-options.component';
import { MoovCommonModule } from '../moov-common/moov-common.module'
import { DoneDiscoveryProcessComponent } from './done-discovery-process/done-discovery-process.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle'; 
import { HttpClientModule } from '@angular/common/http';
import { DiscoveryProcessContainerComponent } from './discovery-process-container/discovery-process-container.component';
import { DiscoveryWizardComponent } from './discovery-wizard/discovery-wizard.component';
import { DiscoveryWizardCurrentQuestionComponent } from './discovery-wizard-current-question/discovery-wizard-current-question.component';
import { DiscoveryWizardResponseComponent } from './discovery-wizard-response/discovery-wizard-response.component';
import { MatIconModule } from '@angular/material/icon';
import { DiscoveryWizardBaseCurrentQuestionComponent } from './discovery-wizard-base-current-question/discovery-wizard-base-current-question.component';
import { DiscoveryWizardCurrentQuestionGapComponent } from './discovery-wizard-current-question-gap/discovery-wizard-current-question-gap.component';
import { DiscoveryWizardCurrentQuestionTailComponent } from './discovery-wizard-current-question-tail/discovery-wizard-current-question-tail.component';
import { DiscoveryWizardSelectableResponseComponent } from './discovery-wizard-selectable-response/discovery-wizard-selectable-response.component';
import { MatDividerModule } from '@angular/material/divider';
import { RediscoverWizardComponent } from './rediscover-wizard/rediscover-wizard/rediscover-wizard.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@NgModule({
  declarations: [
    DiscoveryChatComponent,
    ChatRollComponent,
    ChatCurrentQuestionComponent,
    ChatResponseOptionsComponent,
    DoneDiscoveryProcessComponent,
    DiscoveryProcessContainerComponent,
    DiscoveryWizardComponent,
    DiscoveryWizardCurrentQuestionComponent,
    DiscoveryWizardResponseComponent,
    DiscoveryWizardBaseCurrentQuestionComponent,
    DiscoveryWizardCurrentQuestionGapComponent,
    DiscoveryWizardCurrentQuestionTailComponent,
    DiscoveryWizardSelectableResponseComponent,
    RediscoverWizardComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MoovCommonModule,
    MatDialogModule,
    MatButtonToggleModule,
    HttpClientModule,
    MatProgressBarModule,
    MatDividerModule
  ],
  exports: [
    DiscoveryChatComponent,
    ChatRollComponent,
    ChatCurrentQuestionComponent,
    ChatResponseOptionsComponent,
    DoneDiscoveryProcessComponent,
    DiscoveryWizardCurrentQuestionComponent,
    DiscoveryWizardCurrentQuestionGapComponent,
    DiscoveryWizardCurrentQuestionTailComponent
  ]
})
export class DiscoveryProcessModule { }
